export enum CreditStatus {
  NOT_SUBMITTED,
  APPROVED,
  DENIED,
  IN_REVIEW,
  UNEXPIRED,
  SUBMITTED,
  EXPIRED
}
